import * as React from "react";

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={39.581} height={39.58} viewBox="0 0 39.581 39.58" {...props}>
      <g data-name="Group 73">
        <path
          data-name="Path 125"
          d="M34.806 34.007h-2.5v-1.362a3.43 3.43 0 00-3.414-3.414H10.696a3.434 3.434 0 00-3.413 3.416v1.362h-2.5A3.429 3.429 0 011.369 30.6V20.417a3.428 3.428 0 013.411-3.412h30.028a3.428 3.428 0 013.414 3.409v10.181a3.429 3.429 0 01-3.411 3.414z"
          fill="#7620ff"
        />
        <path
          data-name="Path 126"
          d="M34.804 15.64h-3.525V4.777A4.784 4.784 0 0026.504 0H13.081a4.785 4.785 0 00-4.775 4.777v10.862H4.781a4.784 4.784 0 00-4.778 4.777v10.177a4.785 4.785 0 004.778 4.776h1.175a4.782 4.782 0 004.74 4.208h18.2a4.785 4.785 0 004.738-4.209h1.175a4.786 4.786 0 004.778-4.776V20.417a4.784 4.784 0 00-4.783-4.777zM11.034 4.778A2.069 2.069 0 0113.08 2.73h13.423a2.068 2.068 0 012.046 2.048V15.64H11.034zm17.857 32.073h-18.2a2.066 2.066 0 01-1.955-1.479 1.944 1.944 0 01-.094-.568v-2.159a2.07 2.07 0 012.049-2.046h18.2a2.068 2.068 0 012.047 2.046v2.159a1.943 1.943 0 01-.093.568 2.068 2.068 0 01-1.954 1.479zm7.962-6.256a2.072 2.072 0 01-2.049 2.048h-1.137a4.787 4.787 0 00-4.776-4.776h-18.2a4.788 4.788 0 00-4.778 4.778H4.776a2.073 2.073 0 01-2.049-2.048v-10.18a2.072 2.072 0 012.049-2.049h30.025a2.071 2.071 0 012.049 2.049z"
          fill="#0b093b"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
